const testDownloadConfigEnvs = new Set([
  'development',
  'dev',
  'alpha',
  'test',
  'testing',
  'local'
])

export const resolveDownloadConfigFileName = (env = process.env) => {
  const appEnv = env.VUE_APP_ENV || env.VUE_APP_BUILD_ENV
  const normalizedEnv = String(appEnv || '').toLowerCase()

  if (testDownloadConfigEnvs.has(normalizedEnv)) {
    return 'downloadConfig-test.json'
  }

  return 'downloadConfig.json'
}
